if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      this.cartNotification = document.querySelector('cart-notification');

      this.rechargeATC()
      this.stickyAtc()
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    rechargeATC() {
      // Check if recharge has loaded so we can bind the ATC function
      let count = 0;
      this.interval = setInterval(()=> {
        if(this.querySelector(".rc-widget")){
          const rc = this.querySelector(".rc-widget");
          const rcradios = rc.querySelectorAll("input[type=radio]");
          rcradios.forEach((radio)=> {
            radio.addEventListener('click', this.onSubmitHandler.bind(this));
          }); 
          clearInterval(this.interval);
        }
        if(count >= 5) clearInterval(this.interval); // clear the interval if nothing is found after 5 attempts
      }, 1000);
    }

    stickyAtc() {
      //Product ATC intersection Observer
      let options = {
        rootMargin: '0px',
        threshold: 0
      }

      const target = document.querySelector('.target');
      const productTitle = this.querySelector('.sticky-pdp-title');
      const productATCbtn = this.form;
      const observer = new IntersectionObserver(callback, options);
      observer.observe(target);

      let previousY = 0;
      let previousRatio = 0;

      function callback(entries, observer) {
        entries.forEach(entry => {
          const currentY = entry.boundingClientRect.y;
          const currentRatio = entry.intersectionRatio;

          if (currentY < previousY && currentY < 0 && currentRatio < previousRatio){
              productATCbtn.classList.add('sticky-button');
              productTitle.style.display = "block";

          } else if(currentRatio > previousRatio){
            productATCbtn.classList.remove('sticky-button');
            productTitle.style.display = "none";

          }

          previousY = currentY;
          previousRatio = currentRatio;

        }) 
      }
    }

  });
}


